
export default {
  data() {
    return {
      showPassword: false,

      socialButtons: [
        {
          name: "Facebook",
          img: "/images/facebook.svg",
        },
        {
          name: "Google",
          img: "/images/google.svg",
        },
      ],
    };
  },
};
